import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FuseCardComponent } from '@fuse/components/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { isPlatformBrowser, NgFor, NgIf, NgClass } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FooterComponent } from 'app/modules/landing/footer/footer.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Attachment, IEntityAttachment, IResponse } from 'app/core/shared-services/shared-interface.types';
import Swal from 'sweetalert2';
import { AuthService } from 'app/core/auth/auth.service';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@Component({
  standalone: true,
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  imports: [
      MatSlideToggleModule, MatBadgeModule, FuseCardComponent, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, 
      FormsModule, NgIf, MatInputModule, FooterComponent, MatIconModule, SharedMethodsModule, MatSelectModule, NgFor,
      NgClass, RouterLink, MatProgressSpinnerModule
    ]
})
export class ProfileComponent {
  public selectedButton: string = 'details';
  public accountForm: UntypedFormGroup;
  public billingForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public surname: UntypedFormControl;
  public email: UntypedFormControl;
  public phoneNumber: UntypedFormControl;
  public idNumber: UntypedFormControl;
  public streetAddress: UntypedFormControl;
  public unitNumber: UntypedFormControl;
  public province: UntypedFormControl;
  public country: UntypedFormControl;
  public postalCode: UntypedFormControl;
  public customerAccount: any;
  public uploadedId: boolean;
  public uploadedProof: boolean;
  public documentsUploading: boolean;
  public proofFileName: string;
  public idFileName: string;
  public provinces: string[] = [
    'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal',
    'Limpopo', 'Mpumalanga', 'Northern Cape', 'North West', 'Western Cape'
  ];
  public selectedProvince: string = '';
  public displayedIdNumber: string;
  public allRicaDocumentsUploaded: boolean;


  private accountId: number;

  private referrer: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _sharedMethods: SharedMethodsModule,
    private _authService: AuthService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private _gtmService: GtmService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {

  }

  async ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      
      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

      this._gtmService.dashboardReferrer = this.referrer;

      const route = window.location.href;
      const path = this.router.url;
      this._gtmService.pushEvent({ 
        event: 'page_view' ,
        page_url: route,
        page_path: path,
        page_title: 'profile_page',
        page_referrer: this.referrer ? this.referrer : route
      });
    }

    
    this.accountForm = this.formBuilder.group({
      name: [this.name],
      surname: [this.surname],
      email: [this.email],
      phoneNumber: [this.phoneNumber],
      idNumber: [this.idNumber],
    });

    this.billingForm = this.formBuilder.group({
      streetAddress: [this.streetAddress],
      unitNumber: [this.unitNumber],
      province: [this.province],
      country: [this.country],
      postalCode: [this.postalCode],
    });

    await this.getAccountDetails();
    await this.getAllAttachments();

    const fragment = this.activatedRouter.snapshot.fragment;
    if (fragment === 'rica') {
      this.selectButton("rica")
    }

  }


  public selectButton(button: string) {
    this.selectedButton = button;
  }


  public async uploadRica(object: any, type: any) {
    this.documentsUploading = true;
    const formData = new FormData()
    formData.append('file', object, object.name)
    await this._sharedMethods.uploadFile(formData).then(async (res: IResponse) => {
      if (res?.success) {
        // debugger

        const route = window.location.href;
        const path = this.router.url;
        this.referrer = this._gtmService.dashboardReferrer;
        this._gtmService.pushEvent({ 
          event: type == 'IDDOCUMENT' ? 'upload_ID_document' : 'upload_proof_of_address',
          page_url: route,
          page_path: path,
          page_title: 'profile_page',
          page_referrer: this.referrer ? this.referrer : route
        });

        const attachment: Attachment = {
          "EntityID": this.accountId,
          "FileID": res.result?.FileID,
          "EntityAttachmentName": res.result?.FileName,
          "Notes": type,
          "IsPrimaryAttachment": false,
        }
        await this._sharedMethods.attachment(attachment).then((res: IResponse) => {
          this.documentsUploading = false;
          if(res.success){
            Swal.fire({
              timer: 3000,
              toast: true,
              position: 'bottom-end', 
              title: 'File Uploaded!',
              icon: 'success',
              showConfirmButton: false,
              showCancelButton: false,
              customClass: {
                htmlContainer: 'text-lg',
                confirmButton: 'custom-button text-md',
              }
            });
            this.getAllAttachments();
          }
        });
      }
    });
  }


  public fileTriggers() {
    if (isPlatformBrowser(this.platformId)) {
      const fileInput = (elementId: string): void => {
        const fileInput = document.getElementById(elementId) as HTMLInputElement;
        fileInput.click();
      };
      
  
      const onFileSelected = (event: any, type: any): void => {
        const file = event.target.files[0];
        if (file) {
          this.uploadRica(file, type);
        }
      };
  
      return { fileInput, onFileSelected };
    }
  }


  public async saveCustomerDetails() {

    const data = {
      PrimaryContactName          : this.accountForm.value.name,
      PrimaryContactLastName      : this.accountForm.value.surname,
      PrimaryContactEmail         : this.accountForm.value.email,
      PrimaryContactMobile        : this.accountForm.value.phoneNumber,
      IDNumber                    : this.accountForm.value.idNumber,

      PhysicalAddressLine1        : this.billingForm.value.unitNumber,
      PhysicalAddressLine2        : this.billingForm.value.streetAddress,
      PhysicalAddressLine3        : this.billingForm.value.province,
      PhysicalAddressLine4        : this.billingForm.value.country,
      PhysicalAddressPostalCode   : this.billingForm.value.postalCode
    }

    const updatedObject = {...this.customerAccount, ...data}
    
    await this._sharedMethods.updateCustomerAccount(updatedObject).then((res: IResponse)=>{
      if(res.success){
        Swal.fire({
          timer: 3000,
          toast: true,
          position: 'bottom-end', 
          title: 'Profile Updated!',
          icon: 'success',
          showCancelButton: false,
          showConfirmButton: false,
          customClass: {
            htmlContainer: 'text-lg',
            confirmButton: 'custom-button text-md',
          }
        });
      }else{
        Swal.fire({
          title: 'Incorrect Otp!',
          icon: 'error',
          text: 'our details could not be updated, please contact support if this error persists',
          showCancelButton: false,
          confirmButtonText: 'OKAY',
          showConfirmButton: true,
          customClass: {
            htmlContainer: 'text-xl',
            confirmButton: 'custom-button text-lg',
          }
        });
      }
    });
  }

  private getChangedValues(original: any, updated: any): any {
    const changes: any = {};
    for (const key in updated) {
      if (updated[key] !== original[key]) {
        changes[key] = updated[key];
      }
    }
    return changes;
  }

  public resetPassword(){
    const email = this.accountForm.get('email').value;
    localStorage.setItem("email", email)

    this._authService.forgotPassword(email).subscribe({
      next:()=>{
        Swal.fire({
          title: 'Password Sent!',
          icon: 'success',
          text: 'Please check your email for reset instructions.',
          showCancelButton: false,
          confirmButtonText: 'OKAY',
          showConfirmButton: true,
          customClass: {
            htmlContainer: 'text-lg',
            confirmButton: 'custom-button text-md',
          }
        });
      }
    });
  }

  private async getAccountDetails() {
    this.customerAccount = await this._sharedMethods.getCustomerAccount();
    this.customerAccount = this.customerAccount.result;

    if (this.customerAccount) {
      this.accountId = this.customerAccount?.EntityAccountEntityID;
      const id : string = this.customerAccount?.IDNumber;
      this.displayedIdNumber = id?.substring(0,6) + '*******';
    }

    this.accountForm.patchValue({
      name: this.customerAccount?.PrimaryContactName,
      surname: this.customerAccount?.PrimaryContactLastName,
      email: this.customerAccount?.PrimaryContactEmail,
      phoneNumber: this.customerAccount?.PrimaryContactMobile,
      idNumber: this.customerAccount?.IDNumber
    });

    this.billingForm.patchValue({
      streetAddress: this.customerAccount?.PhysicalAddressLine2,
      unitNumber: this.customerAccount?.PhysicalAddressLine1,
      province: this.customerAccount?.PhysicalAddressLine3,
      country: this.customerAccount?.PhysicalAddressLine4,
      postalCode: this.customerAccount?.PhysicalAddressPostalCode
    });

  }
  
  private async getAllAttachments() {
    await this._sharedMethods.getAllAttachments(this.accountId).then((res: IResponse) => {
      if (res?.success) {
        const proofAttachments: IEntityAttachment[] = [];
        const idAttachments: IEntityAttachment[] = [];
        const attachments: IEntityAttachment[] = res?.result?.Attachments;
        attachments.filter(element => {
          if(element?.Notes === "PROOFOFRESIDENCE"){
            proofAttachments.push(element);
          }
          if(element?.Notes === "IDDOCUMENT"){
            idAttachments.push(element);
          }
        });
        const proofAttachment:IEntityAttachment = proofAttachments.sort((a, b) => Number(new Date(b.CreatedDate)) - Number(new Date(a.CreatedDate)))[0];
        const IdAttachment:IEntityAttachment = idAttachments.sort((a, b) => Number(new Date(b.CreatedDate)) - Number(new Date(a.CreatedDate)))[0];
        this.uploadedProof = proofAttachment ? true : false;
        this.uploadedId = IdAttachment ? true : false;
        this.idFileName = IdAttachment?.FileName;
        this.proofFileName = proofAttachment?.FileName;

        if (this.uploadedProof && this.uploadedId) {
          if (!this._gtmService.allRicaDocumentsUploaded) {
              this._gtmService.allRicaDocumentsUploaded = true;
              const route = window.location.href;
              const path = this.router.url;
              this.referrer = this._gtmService.dashboardReferrer;
              this._gtmService.pushEvent({ 
                  event: 'upload_RICA_documents',
                  page_url: route,
                  page_path: path,
                  page_title: 'profile_page',
                  page_referrer: this.referrer ? this.referrer : route
              });
          }
        }
      }
    });
  }




}



